<!---<div *ngFor='let route of routes'>
  <a [href]='route.path'>{{ route.path }}</a>
  <button (click)='copyLink(route.path)'>Copy Link</button>
</div> -->

<app-default-card title="Allgemeine Links">
  <div>
    <a href="{{ basePath + 'tm/home' }}">Startseite Installateure</a>
  </div>
</app-default-card>

<app-default-card *ngIf="this.dataShareService.tenantConfig" title="Links zu externen Anmeldeprozessen">
  <section>
    <h3>Ladeeinrichtungen</h3>
    <a href="{{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Charger) }}">
      {{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Charger) }}
    </a>
    <button
      mat-raised-button
      color="primary"
      (click)="copyLink(gridRegistrationExternalUrl(GridRegistrationTypeEnum.Charger))">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Erzeugungsanlagen</h3>
    <a href="{{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Feeder) }}">
      {{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Feeder) }}
    </a>
    <button
      mat-raised-button
      color="primary"
      (click)="copyLink(gridRegistrationExternalUrl(GridRegistrationTypeEnum.Feeder))">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Speicher als Verbraucher</h3>
    <a href="{{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Storage) }}">
      {{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.Storage) }}
    </a>
    <button
      mat-raised-button
      color="primary"
      (click)="copyLink(gridRegistrationExternalUrl(GridRegistrationTypeEnum.Storage))">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Wärmepumpen / Raumkühlanlagen</h3>
    <a href="{{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.EHeating) }}">
      {{ gridRegistrationExternalUrl(GridRegistrationTypeEnum.EHeating) }}
    </a>
    <button
      mat-raised-button
      color="primary"
      (click)="copyLink(gridRegistrationExternalUrl(GridRegistrationTypeEnum.EHeating))">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Inbetriebnahme für Smart-Meter / intelligentes Messsystem</h3>
    <a href="{{ commissioningExternalUrl + '/imsys-installation' }}">
      {{ commissioningExternalUrl + '/imsys-installation' }}
    </a>
    <button
      mat-raised-button
      color="primary"
      (click)="copyLink(commissioningExternalUrl + '/imsys-installation')">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Inbetriebnahme Ausbau von Gas-Zähler</h3>
    <a href="{{ commissioningExternalUrl + '/disconnection' }}">
      {{ commissioningExternalUrl + '/disconnection' }}
    </a>
    <button mat-raised-button color="primary" (click)="copyLink(commissioningExternalUrl + '/disconnection')">
      Link kopieren
    </button>
  </section>

  <section>
    <h3>Befundprüfung</h3>
    <a href="{{ commissioningExternalUrl + '/inspection' }}">
      {{ commissioningExternalUrl + '/inspection' }}
    </a>
    <button mat-raised-button color="primary" (click)="copyLink(commissioningExternalUrl + '/inspection')">
      Link kopieren
    </button>
  </section>
  <section>
    <h3>Bestellstrecke - Anschlussänderung</h3>
    <a href="{{ connectionChangeExternalUrl }}">
      {{ connectionChangeExternalUrl }}
    </a>
    <button mat-raised-button color="primary" (click)="copyLink(connectionChangeExternalUrl)">
      Link kopieren
    </button>
  </section>
</app-default-card>
